import React, { useMemo } from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";
import OperatingExpense from "./OperatingExpense/OperatingExpense";
import ContractorExpense from "./ContractorExpense/ContractorExpense";
import W21099Summary from "./W21099Summary/W21099Summary";
import ChapterBoardVotingInfo from "./ChapterBoardVotingInfo/ChapterBoardVotingInfo";
import Contributions from "./Contributions/Contributions";
import ScholarshipExpense from "./ScholarshipExpense/ScholarshipExpense";
import VendorData from "./VendorData/VendorData";
import ChapterBoardMember from "./ChapterBoardMember/ChapterBoardMember";

import { asCurrency } from "../../../../utils";
import { useLocation } from "react-router";

const useStyles = makeStyles({
  tabSubTitle: {
    background: "#aaa",
    textTransform: "capitalize"
  }
});

export const ExpenseContent = props => {
  const { reportID, items, defaultItems, chapterFinancial, totalExpense } =
    props;

  const classes = useStyles();
  const query = new URLSearchParams(useLocation().search);

  const chapterID = useMemo(() => {
    return reportID !== "add"
      ? chapterFinancial.chapter.id
      : query.get("chapter");
  }, []);

  const year = useMemo(() => {
    return reportID !== "add" ? chapterFinancial.year : query.get("year");
  });

  return (
    <Box>
      <Typography>
        <strong>Expenses</strong>
      </Typography>
      <Box mb={1} />
      <OperatingExpense
        data={items}
        defaultData={defaultItems}
        chapterID={chapterID}
        year={year}
        {...props}
      />
      <ContractorExpense
        data={items}
        defaultData={defaultItems}
        chapterID={chapterID}
        year={year}
        {...props}
      />
      <ChapterBoardMember
        data={items}
        defaultData={defaultItems}
        chapterID={chapterID}
        year={year}
        {...props}
      />
      <W21099Summary chapterID={chapterID} year={year} {...props} />
      <ChapterBoardVotingInfo chapterID={chapterID} year={year} {...props} />
      <Contributions
        data={items}
        defaultData={defaultItems}
        chapterID={chapterID}
        year={year}
        {...props}
      />
      <ScholarshipExpense
        data={items}
        defaultData={defaultItems}
        chapterID={chapterID}
        year={year}
        {...props}
      />
      <VendorData
        data={items}
        defaultData={defaultItems}
        chapterID={chapterID}
        year={year}
        {...props}
      />
      <Box
        display="flex"
        justifyContent="space-between"
        p={1}
        mb={2}
        className={classes.tabSubTitle}
      >
        <Typography>
          <strong>Total Expenses</strong>
        </Typography>
        <Typography>{asCurrency(totalExpense)}</Typography>
      </Box>
    </Box>
  );
};
